/* import __COLOCATED_TEMPLATE__ from './company-billing-invoice-routing.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { stopClickEvent } from 'sh-www/utils/events';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-billing-invoice-routing';

class AdminCompanyBillingInvoiceRouting extends Component {
  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      this.className,
    );
  }

  get activeCostCodes() {
    return this.args.company.costCodes.filter(( costCode ) => {
      return !costCode.deletedAt && !costCode.hidden;
    });
  }

  get inactiveCostCodes() {
    // company cost codes does not include trashed, so get them off company contacts
    return Object.values(this.args.companyContacts).reduce((accum, { costCodes }) => {
      // only include deleted cost codes
      costCodes.forEach(costCode => {
        // only unique. checking includes works because of same object identity
        if (!accum.includes(costCode) && costCode.deletedAt && !costCode.hidden) {
          accum.push(costCode);
        }
      });

      return accum;
    }, []);
  }

  @action
  onChangeInvoiceRouting(companyContactId, costCodeId) {
    return this.args.onChangeInvoiceRouting(companyContactId, costCodeId);
  }
}

export default AdminCompanyBillingInvoiceRouting;
